import React, {useEffect, useRef, useState} from 'react';
import Tr from "translations/Translations";
import ExpansionProgressPanel from "./ExpansionProgressPanel";
import {connect} from "react-redux";
import DealingsService from "services/DealingsService";
import ProgressStatus from "constants/ProgressStatus";
import Loading from "components/Loading";
import RfxOfferService from "services/RfxOfferService";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import RealizationAmountForm from "components/complex/realizationAmount/RealizationAmountForm";
import {Typography} from "@material-ui/core";
import GridBlock from "components/GridBlock";
import {isNonpublicProcedure} from "constants/ProcedureType";


const RealizationAmountProgress = (
    {
        demandId,
        roundId,
        demandStatistics,
        formSubmit,
        dealingsRealizationValueStatus,
        demandHeader
    }) => {


    const formId = 'realizationValuesForm';
    const [expanded, setExpanded] = useState(false);
    const [working, setWorking] = useState(false);
    const [realizationValues, setRealizationValues] = useState(undefined);
    const curOfferCount = useRef(demandStatistics.numberOfOffers);
    const publishMode = useRef(null)

    useEffect(() => {
        if (curOfferCount.current === 0 && demandStatistics.numberOfOffers > 0) {
            curOfferCount.current = 1;
            DealingsService.getRealizationValueStatus(demandId);
        }
    }, [demandStatistics, demandId])


    const handleSubmit = () => {
        if (dealingsRealizationValueStatus.editable) {
            publishMode.current = null;
            formSubmit[formId]();
        } else {
            setExpanded(false);
        }

    }

    useEffect(() => {


        if (expanded) {
            setWorking(true);
            DealingsService.getRealizationValues(demandId).then(resp => {
                setRealizationValues(resp);
                setWorking(false);
            })

        } else {
            setRealizationValues(undefined);
        }

    }, [expanded, demandId])

    const processPublishUnpublish = async(publish) => {
        const serviceMethod = publish ? DealingsService.publishRealizationAmountValue : DealingsService.unpublishRealizationAmountValue;
        await serviceMethod(demandId);
    }

    const onSubmit = ({dealings}) => {

        setWorking(true);

        const toCompare = realizationValues.dealings;

        const touched = dealings.filter((el, i) => {
            return el.realizationGrossValue !== toCompare[i].realizationGrossValue || el.realizationGrossOptionValue !== toCompare[i].realizationGrossOptionValue
        });

        DealingsService.saveRealizationValues(demandId, {dealings: touched}, publishMode.current).then(() => {
            if(publishMode.current !== null) {
                processPublishUnpublish(publishMode.current).then(()=> {
                    const arr = [];
                    arr.push(DealingsService.getRealizationValueStatus(demandId))
                    arr.push(RfxOfferService.getOffersDecryptionStatus(roundId))
                    Promise.all(arr).finally(()=> {
                        setExpanded(false);
                        setWorking(false);
                    })
                })
            } else {
                const arr = [];
                arr.push(DealingsService.getRealizationValueStatus(demandId))
                arr.push(RfxOfferService.getOffersDecryptionStatus(roundId))
                Promise.all(arr).finally(()=> {
                    setExpanded(false);
                    setWorking(false);
                })
            }
        })
    }

    const handleCancel = () => setExpanded(false);


    const handlePublish = (publish) => {
        publishMode.current = publish;
        formSubmit[formId]();
    }

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), handleCancel, 'outlined', working));
        buttons.push(createButton(Tr('save'), handleSubmit, undefined, working));
        if (dealingsRealizationValueStatus.realizationOfferAmountPublished)
            buttons.push(createButton(Tr('unpublish'), () => handlePublish(false), undefined, working));
        else
            buttons.push(createButton(Tr('publish'), () => handlePublish(true), undefined, working));
        return buttons;
    }

    const getActions = () => {
        if (!dealingsRealizationValueStatus.editable || working || !expanded) return
        return <MultiButton buttons={getButtons()}/>
    }
    const getDetails = () => {
        if (working || !expanded || !realizationValues) return <Loading/>

        return <GridBlock column>
            <Typography variant="h6">{Tr(isNonpublicProcedure(demandHeader.procedureType) ? "realization_value_info_pzp_excluded" : "realization_value_info")}</Typography>
            <RealizationAmountForm
                formId={formId}
                realizationValues={realizationValues}
                onSubmit={onSubmit}
                editable={dealingsRealizationValueStatus.editable}
                required={dealingsRealizationValueStatus.required}
            />
        </GridBlock>
    }

    const handleExpandSave = () => {
        if (expanded) {
            handleSubmit();
        } else {
            setExpanded(true);
        }
    }

    return (
        <ExpansionProgressPanel
            buttonText={expanded ? (dealingsRealizationValueStatus.editable ? Tr('save') : Tr('collapse')) : Tr('details')}
            title={Tr('realization_demand_value')}
            progressAtlText={`${Tr('filled_count_of_total', {
                count: dealingsRealizationValueStatus.dealingsCount - dealingsRealizationValueStatus.notFilledCount,
                total: dealingsRealizationValueStatus.dealingsCount
            })} (${Tr(dealingsRealizationValueStatus.realizationOfferAmountPublished ? 'realization_demand_value_published' : 'realization_demand_value_not_published')})` }
            progress={dealingsRealizationValueStatus.status === ProgressStatus.PROCESSED ? 100 : 0}
            optional={!dealingsRealizationValueStatus.required}
            buttonDisabled={working || dealingsRealizationValueStatus.status === ProgressStatus.UNAVAILABLE}
            onButtonClick={handleExpandSave}
            actions={getActions()}
            details={getDetails()}
            expanded={expanded}

        />
    );
};

RealizationAmountProgress.propTypes = {};

const mapStateToProps = state => {
    return {
        dealingsRealizationValueStatus: state.resources[DealingsService.RESOURCE_DEALING_REALIZATION_VALUE_STATUS],
        formSubmit: state.form
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RealizationAmountProgress);
